import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-728df5e0")

_pushScopeId("data-v-728df5e0")
const _hoisted_1 = {
  key: 0,
  class: "padding5px"
}
const _hoisted_2 = { class: "label-title" }
const _hoisted_3 = { class: "label-content" }
const _hoisted_4 = { class: "padding5px" }
const _hoisted_5 = { class: "label-title" }
const _hoisted_6 = { class: "label-content" }
const _hoisted_7 = { class: "padding5px" }
const _hoisted_8 = { class: "label-title" }
const _hoisted_9 = { class: "label-content" }
const _hoisted_10 = {
  key: 2,
  class: "padding5px"
}
const _hoisted_11 = { class: "label-title" }
const _hoisted_12 = { class: "label-content" }
const _hoisted_13 = { class: "padding5px" }
const _hoisted_14 = { class: "label-title" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "label-title" }, null, -1)
const _hoisted_16 = { class: "label-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_activity = _resolveComponent("activity")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.orderDetail.TypeEnum === '1')
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.ProperAllTextActivationFee), 1),
          _createVNode("label", _hoisted_3, "$" + _toDisplayString(_ctx.orderDetail.Childern[0].Amount), 1)
        ]))
      : (_ctx.orderDetail.TypeEnum === '2')
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextPackageFee), 1),
              _createVNode("label", _hoisted_6, "$" + _toDisplayString(_ctx.orderDetail.Childern[0].Amount), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$wordList.ProperAllTextSuscriptionDuration), 1),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.orderDetail.Months) + " " + _toDisplayString(_ctx.$wordList.ProperAllTextMonth), 1)
            ])
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.ProperAllTextAdditionalApp), 1),
            _createVNode("label", _hoisted_12, "$" + _toDisplayString(_ctx.orderDetail.Childern[0].Amount), 1)
          ])),
    _createVNode("div", _hoisted_13, [
      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$wordList.OrderTotalPrice) + ": $" + _toDisplayString(_ctx.orderDetail.OriginalPrice), 1),
      _hoisted_15,
      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$wordList.ProperAllTextFinalPrice) + ": $" + _toDisplayString(_ctx.orderDetail.TotalPrice), 1)
    ]),
    _createVNode(_component_activity, {
      data: _ctx.orderDetail.Childern,
      total: _ctx.orderDetail.TotalPrice,
      coupon: _ctx.orderDetail.CouponCount,
      before: _ctx.orderDetail.BeforeOncePrice
    }, null, 8, ["data", "total", "coupon", "before"])
  ]))
})